<template>
  <kst-page-details
    :actions="actions"
    @init="handleInit"
  >
    <b-tabs multiline v-model="activeTab" size="is-medium" type="is-boxed">
      <b-tab-item :label="tabs.Details">
        <Details :data="data"/>
        <Invoices :invoiceList="data.InvoiceList"/>
      </b-tab-item>
    </b-tabs>
  </kst-page-details>
</template>

<script>
import Info from "../RcpyInfo.js";
import Model from "../RcpyModel.js";
import Services from "../../../services/Api/RecPayServices.js";

import Details from "./RcpyD_Details.vue";
import Invoices from "./RcpyD_Invoices.vue";

export default {
  components: {
    Details,
    Invoices
  },
  data: () => ({
    actions: [],
    data: {},
    // tabs
    activeTab: 0,
    tabs: {
      Details: Info.Tabs.Details
    }
  }),
  methods: {
    /*** by page ***/

    handleInit(id, loadDetails) {
      this.resetData(id);

      const config = Services.getDetailsData(id);
      loadDetails(config, this.handleInit_Success);
    },
    handleInit_Success(data) {
      this.data = data.Details;
      Model.setDetailsByStatus(this.data);
    },

    /*** custom ***/

    resetData(id) {
      this.access = this.$kst.Access.create(Model.Access);
      this.actions = Model.Details.getActions(id, this.access);
      this.data = {};
    }
  }
}
</script>